export const webTestIds = {
  '/app/task': {
    taskItem: 'taskItem',
    taskList: 'taskList',
  },
  '/app/taskId': {
    sendMessageButton: 'sendMessageButton',
  },
  '/login': {
    emailInput: 'emailInput',
    passwordInput: 'passwordInput',
    submitLogInFormButton: 'submitLogInFormButton',
  },
} as const;

export type WebTestIdsMap = typeof webTestIds;
export type WebTestIdPath = RecursiveTKeys<WebTestIdsMap, string>;
export type WebTestId = RecursiveTValues<WebTestIdsMap, string>;

export const getNestedValue = <T, K extends RecursiveKeys<T>>(obj: T, key: K): ValueForKey<T, K> => {
  const keys = key.split('.');
  // eslint-disable-next-line fp/no-let, @typescript-eslint/no-explicit-any
  let val: any = obj;

  // eslint-disable-next-line fp/no-loops
  for (const k of keys) {
    // eslint-disable-next-line fp/no-mutation
    val = val[k as keyof typeof val];
    if (val === undefined) {
      throw new Error(`Key "${key}" not found in object.`);
    }
  }

  return val;
};

export const getWebTestId = <K extends WebTestIdPath>(key: K): ValueForKey<WebTestIdsMap, K> =>
  getNestedValue(webTestIds, key);
